var $7d2396d9fde5f3f5$exports = {};
$7d2396d9fde5f3f5$exports = {
    "decrease": (args)=>`Reduser ${args.fieldLabel}`,
    "increase": (args)=>`\xd8k ${args.fieldLabel}`,
    "numberField": `Tallfelt`
};


export {$7d2396d9fde5f3f5$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
